import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var USPayoutsIA = function USPayoutsIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "CsLr+g",
    defaultMessage: [{
      "type": 0,
      "value": "Para poder começar a receber pagamentos, tem de associar uma conta bancária à sua conta Faire. Pode fazê-lo da seguinte forma:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "n42bdo",
    defaultMessage: [{
      "type": 0,
      "value": "Aceda às "
    }, {
      "children": [{
        "type": 0,
        "value": "Definições de conta"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "my-account");
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Wbgzp/",
    defaultMessage: [{
      "type": 0,
      "value": "Aceda ao separador "
    }, {
      "children": [{
        "type": 0,
        "value": "Pagamentos"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "VZV1Pe",
    defaultMessage: [{
      "type": 0,
      "value": "Adicione os seus dados bancários, incluindo o nome do titular da conta, o routing number e o número da conta."
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "TmH6zv",
    defaultMessage: [{
      "type": 0,
      "value": "Os pagamentos são emitidos conforme definido no calendário de pagamentos que escolher. Também pode alterar isto no separador "
    }, {
      "children": [{
        "type": 0,
        "value": "Pagamentos."
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};